<template>
    <Content>
        <table>
            <tr v-for="(item, i) in arr" :key="item.label">
                <td>{{item.label}}</td>
                <td @mouseenter="handleOver(i)" class="td-tree">
                  <a-tree-select
                    class="tree"
                    v-if="item.key ==='deptId'"
                    :disabled="item.disabled"
                    :value="item.value"
                    style="width: 100%; border: none"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="treeData"
                    tree-default-expand-all
                    @change="(v) => onChange(v, i)"
                >
                </a-tree-select>
                    <a-input v-else-if="!item.tag" :focus="item.disabled" :disabled="item.disabled" type="text" v-model="item.value" @blur="getValue(i)"/>
                    <!-- <a-tag v-else>
                            {{item.value}}
                    </a-tag> -->
                    <span v-else>
                        <a-tag v-for="ele in item.value" :key="ele">
                            {{ele}}
                        </a-tag>
                    </span>
                    <span v-if="item.key === 'deptId' && useStatus === '1'" style="color: purple">(停用)</span>
                    <span v-if="item.key === 'deptId' && useStatus === '2'" style="color: #FF9C00">(待生效)</span>
                    <span v-if="!item.tag">
                        <a-icon v-show="index === i" type="edit" @click="handleClick(i)"/>
                    </span>
                </td>
            </tr>
            </table>
    </Content>
</template>

<script>
//updateUserInfo
import {mapMutations} from 'vuex'
import {getUserInfo, getDeptTree, updateUserInfo} from '@/api/back.js'
import Content from '../components/content.vue'
const reg1 = new RegExp(
  '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
); // 校验手机号

//邮箱
const reg2 = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export default {
    components: {
        Content
    },
    data: () => ({
        //获取数据后处理
        arr: [
            {
                value: '',
                label: '用户名',
                key: 'nickName',
                disabled: true
            },
            {
                value: '',
                label: '手机号',
                key: 'phonenumber',
                disabled: true
            },
            {
                value: '',
                label: '邮箱',
                key: 'email',
                disabled: true
            },
            {
                value: '',
                label: '所属部门',
                key: 'deptId',
                disabled: true
            },
            {
                value: '',
                label: '账号角色',
                key: 'remark',
                tag: true
            }
        ],
        treeData: [],
        index: -1, // 鼠标滑到第几个
        useStatus: '',
        id: null,
        roleId: []
    }),
    async created() {
        const {data} = await getDeptTree()
        if(data?.length) {
            // rows.forEach(item => {
            //     item.key = item.deptId
            //     item.value = item.deptId
            //     item.title = item.deptName
            // })
           this.treeData = this.recursion(data)
        }
        this.getUserInfo()
    },
    methods: {
        ...mapMutations({
           setNickName: 'user/SET_NICKNAME'
        }),
        async getUserInfo() {
          const {user} = await getUserInfo()
          console.log('data', user)
          this.useStatus = user.useStatus
          this.id = user.id
          const len = this.arr.length-1
          for (let index = 0; index < len; index++) {
              this.arr[index].value = user[this.arr[index].key]
          }
          const roleName = []
          this.roleId = []
          user.roles.forEach(item => {
              roleName.push(item.roleName)
              this.roleId.push(item.roleId)
          })
          this.arr[len].value = roleName
        },
        handleOver(i) {
            if(this.arr[i].key === 'deptId' && this.useStatus !== '0') return
            this.index = i
        },
        handleOut(i) {
           this.$set(this.arr[i], 'disabled', true) 
        },
        async getValue(i) {
            if(this.arr[i].key === 'phonenumber' && !reg1.test(this.arr[i].value)) {
                this.$message.warn('请输入正确的手机号')
                return
            }
            if(this.arr[i].key === 'email' && !reg2.test(this.arr[i].value)) {
                this.$message.warn('请输入正确的邮箱')
                return
            }
            this.$set(this.arr[i], 'disabled', true)
            this.update(i)
        },
        onChange(v, i) {
            this.$set(this.arr[i], 'value', v)
            this.$set(this.arr[i], 'disabled', true) 
            this.update(i)
        },
        async update() {
            const data = {
                email: this.arr[2].value,
                deptId: this.arr[3].value,
                phonenumber: this.arr[1].value,
                nickName: this.arr[0].value,
                roleIds: this.roleId,
                id: this.id
            }
            const res = await updateUserInfo(data)
            if(res.code === 200) {
               this.$message.success(res.msg)
               this.setNickName(this.arr[0].value)
               this.getUserInfo()
            } else {
                this.$message.error(res.msg)
                this.getUserInfo()
            }
        },
        handleClick(i) {
            this.$set(this.arr[i], 'disabled', false)
        },
        recursion(list) {
            list.forEach((item) => {
                item.key = item.deptId
                item.value = item.deptId
                item.title = item.deptName
                if (item.children && item.children.length) {
                this.recursion(item.children)
                }
            })
            return list
            },
        getTreeList(list, id) {
            return list.reduce((pre, cur) => {
                if (cur.parentId === id) {
                const children = this.getTreeList(list, cur.deptId);
                if (children.length) {
                    cur.children = children;
                }
                pre.push(cur);
                }
                return pre;
            }, []);
        },
    }
}
</script>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    width: 65%;
    height: 256px;
    margin-top: 15px;
}

table, td, tr {
    border: 1px solid #CBD7EB;
    
}
td:last-child {
   padding-left: 10px;
   cursor: pointer;
   position: relative;
   input {
      width: 180px !important;
    //   outline: none;
    //   border: none;
  }
}
  .ant-select {
    width: 180px !important;
    outline: none !important;
    border: none !important;
}
.ant-select-disabled  {
    border: none !important;
  }
.ant-select-selection.ant-select-selection--single {
    border: none !important;
}

td:first-child {
  background-color: #EFF3FA;
  text-align: center;
  width: 123px;
  
}
.tree{
  .ant-select-disabled  {
      border: none !important;
  }
.ant-select-selection {
    border: none !important;
}
.ant-select-selection--single {
    border: none !important;
 }
}
</style>